import { render } from "./UserListComponent.vue?vue&type=template&id=2f37ab22&scoped=true"
import script from "./UserListComponent.vue?vue&type=script&lang=js"
export * from "./UserListComponent.vue?vue&type=script&lang=js"

import "./UserListComponent.vue?vue&type=style&index=0&id=2f37ab22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f37ab22"]])

export default __exports__